/**
 * Dev/local convenience only: REACT_APP_* is bundled into the client.
 * Set REACT_APP_SKIP_EMAIL_VERIFICATION=true so client-side email verification
 * gates behave as if the user is verified. REACT_APP_BYPASS_EMAIL_VERIFICATION
 * is still accepted for backward compatibility.
 */
export function isEmailVerificationBypassed() {
  return (
    process.env.REACT_APP_SKIP_EMAIL_VERIFICATION === 'true' ||
    process.env.REACT_APP_BYPASS_EMAIL_VERIFICATION === 'true'
  );
}

export function isEmailVerifiedOrBypassed(userInfo) {
  return Boolean(userInfo?.isVerify) || isEmailVerificationBypassed();
}
